import React from 'react';
import { Screen } from 'src/components/screen';
import { AiAssistantContainer } from './container';

const AiAssistantScreen = () => {
  return (
    <Screen
      contentContainerStyle={{ flex: 1, height: '100%', paddingBottom: 0 }}>
      <AiAssistantContainer />
    </Screen>
  );
};

export { AiAssistantScreen };
